import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { createVtoServerConfig } from '../Ditto/utils.js';

const VtoContext = /*#__PURE__*/ React.createContext(null);
VtoContext.displayName = 'VtoContext';
const useVto = ()=>{
    const context = React.useContext(VtoContext);
    if (!context) {
        throw new Error(`No ${VtoContext.displayName} available. You might need to add the ${VtoContext.displayName} provider component.`);
    }
    return context;
};
const VtoProvider = ({ dittoConfig , virtualMirrorConfig , children  })=>{
    const { locale  } = useIntl();
    const { featureConfigs , isVtoEnabled  } = useFeatureToggles();
    const isVirtualMirrorEnabled = (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.virtualTryOn) === 'VIRTUAL_MIRROR';
    const isDittoEnabled = (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.virtualTryOn) === 'DITTO';
    const [isVtoActive, setVtoActive] = React.useState(false);
    const dittoServerConfig = React.useMemo(()=>{
        if (isVtoEnabled && dittoConfig && isDittoEnabled) {
            const serverConfig = createVtoServerConfig(dittoConfig, locale);
            const getSignature = function() {
                var _ref = swcHelpers.asyncToGenerator(function*(message) {
                    return fetch(`${serverConfig.signatureRoute}?message=${message}`).then((response)=>response.json()
                    ).then(({ signature  })=>signature
                    );
                });
                return function getSignature(message) {
                    return _ref.apply(this, arguments);
                };
            }();
            return swcHelpers.objectSpread({}, serverConfig, {
                getSignature,
                isEnabled: true
            });
        }
        return {
            isEnabled: false
        };
    }, [
        dittoConfig,
        isVtoEnabled,
        locale,
        isDittoEnabled
    ]);
    const config = isVirtualMirrorEnabled ? virtualMirrorConfig : dittoServerConfig;
    const value = {
        config,
        isVtoActive,
        setVtoActive,
        isVtoFeatureEnabled: isVtoEnabled
    };
    return /*#__PURE__*/ React.createElement(VtoContext.Provider, {
        value: value
    }, children);
};

export { VtoContext, VtoProvider, useVto };
//# sourceMappingURL=VtoProvider.js.map
